import {gql, useQuery} from '@apollo/client';

import feeTypesQuery from '../graphql/query/feeTypes.graphql';

import {getLog} from '../log';
import {FeeType} from '../model';

const log = getLog('useFeeTypes', 'DEBUG');

interface FeeTypesQuery {
  feeTypes: FeeType[];
}

export interface UseFeeTypes {
  getFeeName: (feeTypeId: string) => string;
  loading: boolean;
}

export const useFeeTypes = (): UseFeeTypes => {
  const {loading, data: {feeTypes} = {}} = useQuery<FeeTypesQuery>(gql(feeTypesQuery), {fetchPolicy: 'cache-first'});

  log.debug('useFeeTypes', {loading, feeTypes});

  const getFeeName = (feeTypeId: string): string =>
    feeTypes?.find((type) => type.id.equalsIgnoreCase(feeTypeId))?.name || feeTypeId;

  return {
    getFeeName,
    loading,
  };
};
